var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMoneyCoins(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 40,
    viewBox: "0 0 42 40",
    width: 42,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-3 -5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h48v48h-48z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m18 31.8h-10.2c-2.1 0-3.8-1.7-3.8-3.8v-18.2c0-2.1 1.7-3.8 3.8-3.8h30.4c2.1 0 3.8 1.7 3.8 3.8v10.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12 26h-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36 12h-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37 40c-3.866 0-7-3.134-7-7s3.134-7 7-7c3.868 0 7 3.134 7 7s-3.132 7-7 7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.66 30.036c-3.704.18-6.66 3.216-6.66 6.964 0 3.866 3.134 7 7 7 2.794 0 5.186-1.648 6.31-4.016"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.358 15.942c1.854 1.854 1.854 4.862 0 6.718-1.854 1.854-4.862 1.854-6.718 0-1.854-1.854-1.854-4.862 0-6.718 1.856-1.856 4.864-1.856 6.718 0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyCoins);
export default __webpack_public_path__ + "static/media/money-coins.a85ab6c721c39039110f81afc8789e9c.svg";
export { ForwardRef as ReactComponent };